<template>
  <div class="section">
    <div style="padding-top: 45px">
      <img :src="images.back1" style="heght: auto; width: 74%" />
      <img
        :src="images.logo"
        style="height: auto; width: 15%; float: right; margin-right: 50px"
      />
    </div>

    <div class="content1">
      <img
        :src="images.icon1"
        style="height: auto%; width: 4%; margin-top: 10px"
      />
      <p style="text-indent: 40px; line-height: 30px; margin-top: -30px">
        {{ content1 }}
      </p>
    </div>

    <div class="content2" v-if="isPsychology == true || isBehavior == true">
      <img :src="images.icon2" style="height: auto%; width: 4%" />
      <p style="text-indent: 40px; line-height: 30px; margin-top: -30px">
        {{ content2 }}
      </p>
    </div>
    <div class="content2" v-if="isPersonality == true">
      <img :src="images.icon2" style="height: auto%; width: 4%" />
      <p style="text-indent: 40px; line-height: 30px; margin-top: -30px">
        {{ content2Per }}
      </p>
    </div>
    <!-- 坐标 -->
    <div style="margin-left: 140px; margin-top: 35px">
      <img :src="images.back2" style="height: auto%; width: 90%" />
    </div>

    <div class="showContent">
      <img
        :src="images.back3"
        class="content3"
        style="height: auto%; width: 36.1%"
      />

      <img
        :src="images.back4"
        class="content4"
        style="height: auto%; width: 65%"
      />
    </div>

    <div class="content5" v-if="isPsychology == true || isBehavior == true">
      <p
        style="
          text-indent: 30px;
          line-height: 29px;
          margin-top: -30px;
          font-size: 15px;
        "
      >
        {{ content3 }}
      </p>
    </div>

    <div class="content5" v-if="isPersonality == true">
      <p
        style="
          text-indent: 30px;
          line-height: 29px;
          margin-top: -30px;
          font-size: 15px;
        "
      >
        {{ content3Per }}
      </p>
    </div>
    <div class="content6" v-if="isPsychology == true">
      <img :src="images.icon3" style="height: auto%; width: 5%" />
      <p
        style="
          text-indent: 45px;
          line-height: 29px;
          margin-top: -30px;
          margin-left: -12px;
        "
      >
        {{ content4 }}
      </p>
    </div>

    <div class="content6" v-if="isPersonality == true">
      <p
        style="
          text-indent: 34px;
          line-height: 29px;
          margin-top: -15px;
          margin-left: -12px;
        "
      >
        {{ content4Per }}
      </p>
    </div>

    <div class="content6" v-if="isPsychology == true">
      <img :src="images.icon4" style="height: auto%; width: 5%" />
      <p
        style="
          text-indent: 45px;
          line-height: 29px;
          margin-top: -30px;
          margin-left: -12px;
        "
      >
        {{ content5 }}
      </p>
    </div>

    <div class="content6" v-if="isPersonality == true">
      <img :src="images.icon3" style="height: auto%; width: 5%" />
      <p
        style="
          text-indent: 45px;
          line-height: 29px;
          margin-top: -30px;
          margin-left: -12px;
        "
      >
        {{ content5Per }}
      </p>
    </div>

    <div class="content7" v-if="isBehavior == true">
      <img :src="images.icon3" style="height: auto%; width: 5%" />
      <p
        style="
          text-indent: 45px;
          line-height: 29px;
          margin-top: -30px;
          margin-left: -12px;
        "
      >
        {{ content5Per }}
      </p>
    </div>

    <!-- <div style="text-align: center;margin-top:15px">
      <img :src="images.page" style="height:auto%;width:5%;" />
    </div> -->
  </div>
</template>

<script>
import { readingNotes, readingNotesPer } from "@/views/report/config/three";
export default {
  props: ["isPersonality", "isPsychology", "isBehavior"],
  data() {
    return {
      images: {
        logo: require("../../../assets/images/page1/logo.png"),
        icon1: require("../../../assets/images/page3/1.png"),
        icon2: require("../../../assets/images/page3/2.png"),
        icon3: require("../../../assets/images/page3/3.png"),
        icon4: require("../../../assets/images/page3/4.png"),
        back1: require("../../../assets/images/page3/back1.png"),
        back2: require("../../../assets/images/page3/back2.png"),
        back3: require("../../../assets/images/page3/back3.png"),
        back4: require("../../../assets/images/page3/back4.png"),
        page: require("../../../assets/images/page3/page.png"),
      },
      content1: readingNotes.content1,
      content2: readingNotes.content2,
      content3: readingNotes.content3,
      content4: readingNotes.content4,
      content5: readingNotes.content5,
      content2Per: readingNotesPer.content1,
      content3Per: readingNotesPer.content2,
      content4Per: readingNotesPer.content3,
      content5Per: readingNotesPer.content4,
      info: readingNotes.info,
    };
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  height: 1124px; //A4纸的高度像素
  overflow: hidden;
  .content1 {
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 30px;
  }
  .content2 {
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 15px;
  }

  .showContent {
    position: relative;
    .content3 {
      position: absolute;
      top: -180px;
      z-index: 2;
    }
    .content4 {
      margin-top: 45px;
      margin-left: 165px;
    }
  }
  .content5 {
    padding-left: 310px;
    padding-right: 50px;
    padding-top: 50px;
  }
  .content6 {
    padding-left: 280px;
    padding-right: 50px;
    padding-top: 25px;
  }
  .content7 {
    padding-left: 280px;
    padding-right: 50px;
    padding-top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/pageThree.vue